import {object, string} from 'yup';

export const AdminSignInValidator = object().shape({
  email: string()
    .trim()
    .email('Provide an active email address')
    .required('Provide an active email address'),
});
